document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#main-collection-product-grid');
  if (!grid) return;

  const sortValue = new URLSearchParams(window.location.search).get('sort_by');

  if (sortValue === 'price-ascending' || sortValue === 'price-descending') {
    return;
  }
  const items = Array.from(grid.children);
  const shuffled = items
    .map(item => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item);

  grid.innerHTML = '';
  shuffled.forEach(li => grid.appendChild(li));
});


